import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";
import {
    Personnel,
    PersonnelCategory,
    PersonnelTmdRole,
    PersonnelTmdTrial,
    PersonnelTrialGroup,
    SearchPersonnelAdvanced
} from "../dtos/Tmd.dtos";

export const
    LoadPersonnel: IPersonnelLoadActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_LOAD
        }
    },
    LoadPersonnelById: IPersonnelLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PERSONNEL_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IPersonnelLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IPersonnelLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_LOAD_FAILURE,
            responseStatus
        }
    },

    SavePersonnel: IPersonnelSaveActionCreator = (formData) => {
        return {
            type: ACTION_PERSONNEL_SAVE,
            formData
        }
    },
    SaveSuccess: IPersonnelSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IPersonnelSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_SAVE_FAILURE,
            responseStatus
        }
    },

    SaveActiveDirectory: IPersonnelSaveActiveDirectoryActionCreator = (formData) => {
        return {
            type: ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY,
            formData
        }
    },
    SaveActiveDirectorySuccess: IPersonnelSaveActiveDirectorySuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveActiveDirectoryFailure: IPersonnelSaveActiveDirectoryFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE,
            responseStatus
        }
    },

    CreatePersonnel: IPersonnelCreateActionCreator = () => {

        return {
            type: ACTION_PERSONNEL_CREATE
        }
    },
    CreateSuccess: IPersonnelCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PERSONNEL_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IPersonnelCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidatePersonnel: IPersonnelValidateActionCreator = (formData) => {
        return {
            type: ACTION_PERSONNEL_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IPersonnelValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IPersonnelValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IPersonnelClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PERSONNEL_CLEAR,
            propertiesToClear
        }
    },

    Filter: IPersonnelFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PERSONNEL_FILTER,
            formFilter
        }
    },
    ResendEmail: IPersonnelResendEmailActionCreator = (id) => {
        return {
            type: ACTION_PERSONNEL_RESENDEMAIL,
            id
        }
    },
    ResendEmailSuccess: IPersonnelResendEmailSuccessActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_RESENDEMAIL_SUCCESS,
            responseStatus
        }
    },
    ResendEmailFailure: IPersonnelResendEmailFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_RESENDEMAIL_FAILURE,
            responseStatus
        }
    },
    LoadPersonnelPermissionsById: IPersonnelPermissionsLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID,
            id
        }
    },
    LoadPermissionsSuccess: IPersonnelPermissionsLoadSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS,
            data,
            responseStatus
        }
    },
    LoadPermissionsFailure: IPersonnelPermissionsLoadFailureActionCreator = (responseStatus) => {
            return {
                type: ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE,
                responseStatus
            }
    },

    LoadPersonnelByRole: IPersonnelByRoleLoadActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_BY_ROLE_LOAD
        }
    },
    LoadPersonnelByRoleSuccess: IPersonnelByRoleLoadSuccessActionCreator = (formData, responseStatus) => {
        return {
            type: ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS,
            formData,
            responseStatus
        }
    },
    LoadPersonnelByRoleFailure: IPersonnelByRoleLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE,
            responseStatus
        }
    },
    FilterByRole: IPersonnelFilterByRoleActionCreator = (formFilter) => {
        return {
            type: ACTION_PERSONNEL_FILTER_BY_ROLE,
            formFilter
        }
    },
    AdvancedSearch: IPersonnelAdvancedSearchActionCreator = (searchPersonnelAdvanced: SearchPersonnelAdvanced) => {
        return {
            searchPersonnelAdvanced: searchPersonnelAdvanced,
            type: ACTION_PERSONNEL_ADVANCED_SEARCH
        }
    },
    AdvancedSearchSuccess: IPersonnelAdvancedSearchSuccessActionCreator = (responseStatus: Dtos.ResponseStatus, personnel: Personnel[]) => {
        return {
            responseStatus: responseStatus,
            personnel: personnel,
            type: ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS
        }
    },
    AdvancedSearchFailure: IPersonnelAdvancedSearchFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE,
            responseStatus
        }
    },
    TmdRole: IPersonnelTMDRoleActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_TMD_ROLE
        }
    },
    TmdRoleSuccess: IPersonnelTMDRoleSuccessActionCreator = (responseStatus: Dtos.ResponseStatus, tmdRole: PersonnelTmdRole[]) => {
        return {
            responseStatus: responseStatus,
            tmdRole: tmdRole,
            type: ACTION_PERSONNEL_TMD_ROLE_SUCCESS
        }
    },
    TmdRoleFailure: IPersonnelTMDRoleFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_TMD_ROLE_FAILURE,
            responseStatus
        }
    },
    TmdRoleUpdate: IPersonnelTMDRoleUpdateActionCreator = (tmdRole: PersonnelTmdRole[], searchType: SearchType) => {
        return {
            tmdRole: tmdRole,
            searchType: searchType,
            type: ACTION_PERSONNEL_TMD_ROLE_UPDATE
        }
    },
    TmdTrial: IPersonnelTMDTrialActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_TMD_TRIAL
        }
    },
    TmdTrialSuccess: IPersonnelTMDTrialSuccessActionCreator = (responseStatus: Dtos.ResponseStatus, tmdTrial: PersonnelTmdTrial[]) => {
        return {
            responseStatus: responseStatus,
            tmdTrial: tmdTrial,
            type: ACTION_PERSONNEL_TMD_TRIAL_SUCCESS
        }
    },
    TmdTrialFailure: IPersonnelTMDTrialFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_TMD_TRIAL_FAILURE,
            responseStatus
        }
    },
    TmdTrialUpdate: IPersonnelTMDTrialUpdateActionCreator = (tmdTrial: PersonnelTmdTrial[], searchType: SearchType) => {
        return {
            tmdTrial: tmdTrial,
            searchType: searchType,
            type: ACTION_PERSONNEL_TMD_TRIAL_UPDATE
        }
    },
    Category: IPersonnelCategoryActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_CATEGORY
        }
    },
    CategorySuccess: IPersonnelCategorySuccessActionCreator = (responseStatus: Dtos.ResponseStatus, category: PersonnelCategory[]) => {
        return {
            responseStatus: responseStatus,
            category: category,
            type: ACTION_PERSONNEL_CATEGORY_SUCCESS
        }
    },
    CategoryFailure: IPersonnelCategoryFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_CATEGORY_FAILURE,
            responseStatus
        }
    },
    CategoryUpdate: IPersonnelCategoryUpdateActionCreator = (category: PersonnelCategory[], searchType: SearchType) => {
        return {
            category: category,
            searchType: searchType,
            type: ACTION_PERSONNEL_CATEGORY_UPDATE
        }
    },
    TrialGroup: IPersonnelTrialGroupActionCreator = () => {
        return {
            type: ACTION_PERSONNEL_TRIAL_GROUP
        }
    },
    TrialGroupSuccess: IPersonnelTrialGroupSuccessActionCreator = (responseStatus: Dtos.ResponseStatus, trialGroup: PersonnelTrialGroup[]) => {
        return {
            responseStatus: responseStatus,
            trialGroup: trialGroup,
            type: ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS
        }
    },
    TrialGroupFailure: IPersonnelTrialGroupFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PERSONNEL_TRIAL_GROUP_FAILURE,
            responseStatus
        }
    },
    TrialGroupUpdate: IPersonnelTrialGroupUpdateActionCreator = (trialGroup: PersonnelTrialGroup[], searchType: SearchType) => {
        return {
            trialGroup: trialGroup,
            searchType: searchType,
            type: ACTION_PERSONNEL_TRIAL_GROUP_UPDATE
        }
    };



export const
    ACTION_PERSONNEL_LOAD = "ACTION_PERSONNEL_LOAD",
    ACTION_PERSONNEL_LOAD_BY_ID = "ACTION_PERSONNEL_LOAD_BY_ID",
    ACTION_PERSONNEL_LOAD_SUCCESS = "ACTION_PERSONNEL_LOAD_SUCCESS",
    ACTION_PERSONNEL_LOAD_FAILURE = "ACTION_PERSONNEL_LOAD_FAILURE",

    ACTION_PERSONNEL_SAVE = "ACTION_PERSONNEL_SAVE",
    ACTION_PERSONNEL_SAVE_SUCCESS = "ACTION_PERSONNEL_SAVE_SUCCESS",
    ACTION_PERSONNEL_SAVE_FAILURE = "ACTION_PERSONNEL_SAVE_FAILURE",

    ACTION_PERSONNEL_VALIDATE = "ACTION_PERSONNEL_VALIDATE",
    ACTION_PERSONNEL_VALIDATE_SUCCESS = "ACTION_PERSONNEL_VALIDATE_SUCCESS",
    ACTION_PERSONNEL_VALIDATE_FAILURE = "ACTION_PERSONNEL_VALIDATE_FAILURE",

    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY = "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY",
    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS = "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS",
    ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE = "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE",

    ACTION_PERSONNEL_CREATE = "ACTION_PERSONNEL_CREATE",
    ACTION_PERSONNEL_CREATE_SUCCESS = "ACTION_PERSONNEL_CREATE_SUCCESS",
    ACTION_PERSONNEL_CREATE_FAILURE = "ACTION_PERSONNEL_CREATE_FAILURE",

    ACTION_PERSONNEL_RESENDEMAIL = "ACTION_PERSONNEL_RESENDEMAIL",
    ACTION_PERSONNEL_RESENDEMAIL_SUCCESS = "ACTION_PERSONNEL_RESENDEMAIL_SUCCESS",
    ACTION_PERSONNEL_RESENDEMAIL_FAILURE = "ACTION_PERSONNEL_RESENDEMAIL_FAILURE",

    ACTION_PERSONNEL_CLEAR = "ACTION_PERSONNEL_CLEAR",

    ACTION_PERSONNEL_FILTER = "ACTION_PERSONNEL_FILTER",

    ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID = "ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID",
    ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS = "ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS",
    ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE = "ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE",

    ACTION_PERSONNEL_BY_ROLE_LOAD = "ACTION_PERSONNEL_BY_ROLE_LOAD",
    ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS = "ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS",
    ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE = "ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE",

    ACTION_PERSONNEL_FILTER_BY_ROLE = "ACTION_PERSONNEL_FILTER_BY_ROLE",

    ACTION_PERSONNEL_ADVANCED_SEARCH = "ACTION_PERSONNEL_ADVANCED_SEARCH",
    ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS = "ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS",
    ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE = "ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE",

    ACTION_PERSONNEL_TMD_ROLE = "ACTION_PERSONNEL_TMD_ROLE",
    ACTION_PERSONNEL_TMD_ROLE_SUCCESS = "ACTION_PERSONNEL_TMD_ROLE_SUCCESS",
    ACTION_PERSONNEL_TMD_ROLE_FAILURE = "ACTION_PERSONNEL_TMD_ROLE_FAILURE",

    ACTION_PERSONNEL_TMD_ROLE_UPDATE = "ACTION_PERSONNEL_TMD_ROLE_UPDATE",

    ACTION_PERSONNEL_TMD_TRIAL = "ACTION_PERSONNEL_TMD_TRIAL",
    ACTION_PERSONNEL_TMD_TRIAL_SUCCESS = "ACTION_PERSONNEL_TMD_TRIAL_SUCCESS",
    ACTION_PERSONNEL_TMD_TRIAL_FAILURE = "ACTION_PERSONNEL_TMD_TRIAL_FAILURE",

    ACTION_PERSONNEL_TMD_TRIAL_UPDATE = "ACTION_PERSONNEL_TMD_TRIAL_UPDATE",

    ACTION_PERSONNEL_CATEGORY = "ACTION_PERSONNEL_CATEGORY",
    ACTION_PERSONNEL_CATEGORY_SUCCESS = "ACTION_PERSONNEL_CATEGORY_SUCCESS",
    ACTION_PERSONNEL_CATEGORY_FAILURE = "ACTION_PERSONNEL_CATEGORY_FAILURE",

    ACTION_PERSONNEL_CATEGORY_UPDATE = "ACTION_PERSONNEL_CATEGORY_UPDATE",

    ACTION_PERSONNEL_TRIAL_GROUP = "ACTION_PERSONNEL_TRIAL_GROUP",
    ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS = "ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS",
    ACTION_PERSONNEL_TRIAL_GROUP_FAILURE = "ACTION_PERSONNEL_TRIAL_GROUP_FAILURE",

    ACTION_PERSONNEL_TRIAL_GROUP_UPDATE = "ACTION_PERSONNEL_TRIAL_GROUP_UPDATE";

export interface IPersonnelLoadAction {
    type: "ACTION_PERSONNEL_LOAD";
}

export interface IPersonnelLoadActionCreator {
    (): IPersonnelLoadAction;
}

export interface IPersonnelLoadSuccessAction {
    type: "ACTION_PERSONNEL_LOAD_SUCCESS";
    formData: Dtos.Personnel | Dtos.Personnel[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelLoadSuccessActionCreator {
    (
        formData: Dtos.Personnel | Dtos.Personnel[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelLoadSuccessAction;
}

export interface IPersonnelLoadFailureAction {
    type: "ACTION_PERSONNEL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelLoadFailureAction;
}

export interface IPersonnelLoadByIdAction {
    type: "ACTION_PERSONNEL_LOAD_BY_ID";
    id: number;
}

export interface IPersonnelLoadByIdActionCreator {
    (id: number): IPersonnelLoadByIdAction;
}


export interface IPersonnelSaveAction {
    type: "ACTION_PERSONNEL_SAVE";
    formData: Dtos.Personnel;

}

export interface IPersonnelSaveActionCreator {
    (
        formData: Dtos.Personnel
    ): IPersonnelSaveAction;
}

export interface IPersonnelSaveSuccessAction {
    type: "ACTION_PERSONNEL_SAVE_SUCCESS";
    formData: Dtos.Personnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelSaveSuccessActionCreator {
    (
        formData: Dtos.Personnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelSaveSuccessAction;
}

export interface IPersonnelSaveFailureAction {
    type: "ACTION_PERSONNEL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelSaveFailureAction;
}

export interface IPersonnelValidateAction {
    type: "ACTION_PERSONNEL_VALIDATE";
    formData: Dtos.Personnel;

}

export interface IPersonnelValidateActionCreator {
    (
        formData: Dtos.Personnel
    ): IPersonnelValidateAction;
}

export interface IPersonnelValidateSuccessAction {
    type: "ACTION_PERSONNEL_VALIDATE_SUCCESS";
    formData: Dtos.Personnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelValidateSuccessActionCreator {
    (
        formData: Dtos.Personnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelValidateSuccessAction;
}

export interface IPersonnelValidateFailureAction {
    type: "ACTION_PERSONNEL_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelValidateFailureAction;
}


export interface IPersonnelSaveActiveDirectoryAction {
    type: "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY";
    formData: Dtos.Personnel;

}

export interface IPersonnelSaveActiveDirectoryActionCreator {
    (
        formData: Dtos.Personnel
    ): IPersonnelSaveActiveDirectoryAction;
}

export interface IPersonnelSaveActiveDirectorySuccessAction {
    type: "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_SUCCESS";
    formData: Dtos.Personnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelSaveActiveDirectorySuccessActionCreator {
    (
        formData: Dtos.Personnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelSaveActiveDirectorySuccessAction;
}

export interface IPersonnelSaveActiveDirectoryFailureAction {
    type: "ACTION_PERSONNEL_SAVE_ACTIVE_DIRECTORY_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelSaveActiveDirectoryFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelSaveActiveDirectoryFailureAction;
}


export interface IPersonnelResendEmailAction {
    type: "ACTION_PERSONNEL_RESENDEMAIL";
    id: number;
}

export interface IPersonnelResendEmailActionCreator {
    (id: number): IPersonnelResendEmailAction;
}

export interface IPersonnelResendEmailSuccessAction {
    type: "ACTION_PERSONNEL_RESENDEMAIL_SUCCESS";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelResendEmailSuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelResendEmailSuccessAction;
}

export interface IPersonnelResendEmailFailureAction {
    type: "ACTION_PERSONNEL_RESENDEMAIL_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelResendEmailFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelResendEmailFailureAction;
}

export interface IPersonnelCreateAction {
    type: "ACTION_PERSONNEL_CREATE"
}

export interface IPersonnelCreateActionCreator {
    (): IPersonnelCreateAction
}

export interface IPersonnelCreateSuccessAction {
    type: "ACTION_PERSONNEL_CREATE_SUCCESS";
    formData: Dtos.Personnel;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IPersonnelCreateSuccessActionCreator {
    (
        formData: Dtos.Personnel,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IPersonnelCreateSuccessAction;
}

export interface IPersonnelCreateFailureAction {
    type: "ACTION_PERSONNEL_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IPersonnelCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelCreateFailureAction;
}

export interface IPersonnelClearAction {
    type: "ACTION_PERSONNEL_CLEAR";
    propertiesToClear?: string[];
}

export interface IPersonnelClearActionCreator {
    (propertiesToClear?: string[]): IPersonnelClearAction;
}

export interface IPersonnelFilterActionCreator {
    (formFilter: IFormFilter): IPersonnelFilterAction;
}

export interface IPersonnelFilterAction {
    type: "ACTION_PERSONNEL_FILTER";
    formFilter: IFormFilter;
}

export interface IPersonnelPermissionsLoadByIdAction {
    type: "ACTION_PERSONNEL_PERMISSIONS_LOAD_BY_ID";
    id: number;
}

export interface IPersonnelPermissionsLoadByIdActionCreator {
    (id: number): IPersonnelPermissionsLoadByIdAction;
}

export interface IPersonnelPermissionsLoadSuccessAction {
    type: "ACTION_PERSONNEL_PERMISSIONS_LOAD_SUCCESS";
    data: Dtos.PersonnelPermissionGroup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelPermissionsLoadSuccessActionCreator {
    (
        data: Dtos.PersonnelPermissionGroup[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelPermissionsLoadSuccessAction;
}

export interface IPersonnelPermissionsLoadFailureAction {
    type: "ACTION_PERSONNEL_PERMISSIONS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelPermissionsLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelPermissionsLoadFailureAction;
}

export interface IPersonnelByRoleLoadAction {
    type: "ACTION_PERSONNEL_BY_ROLE_LOAD";
}

export interface IPersonnelByRoleLoadActionCreator {
    (): IPersonnelByRoleLoadAction;
}

export interface IPersonnelByRoleLoadSuccessAction {
    type: "ACTION_PERSONNEL_BY_ROLE_LOAD_SUCCESS";
    formData: Dtos.RolePersonnelGrouping[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelByRoleLoadSuccessActionCreator {
    (
        formData: Dtos.RolePersonnelGrouping[],
        responseStatus: Dtos.ResponseStatus
    ): IPersonnelByRoleLoadSuccessAction;
}

export interface IPersonnelByRoleLoadFailureAction {
    type: "ACTION_PERSONNEL_BY_ROLE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelByRoleLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelByRoleLoadFailureAction;
}

export interface IPersonnelFilterByRoleActionCreator {
    (formFilter: IFormFilter): IPersonnelFilterByRoleAction;
}

export interface IPersonnelFilterByRoleAction {
    type: "ACTION_PERSONNEL_FILTER_BY_ROLE";
    formFilter: IFormFilter;
}

// -------

export interface IPersonnelAdvancedSearchActionCreator {
    (searchPersonnelAdvanced: SearchPersonnelAdvanced): IPersonnelAdvancedSearchAction
}

export interface IPersonnelAdvancedSearchAction {
    searchPersonnelAdvanced: SearchPersonnelAdvanced,
    type: "ACTION_PERSONNEL_ADVANCED_SEARCH"
}

export interface IPersonnelAdvancedSearchSuccessAction {
    type: "ACTION_PERSONNEL_ADVANCED_SEARCH_SUCCESS";
    personnel: Personnel[]
}

export interface IPersonnelAdvancedSearchFailureAction {
    type: "ACTION_PERSONNEL_ADVANCED_SEARCH_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelAdvancedSearchSuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus,
        personnel: Personnel[]
    ): IPersonnelAdvancedSearchSuccessAction;
}

export interface IPersonnelAdvancedSearchFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelAdvancedSearchFailureAction;
}

// ----- TMD Role

export enum SearchType
{
    Search = 1,
    SearchAND = 2,
    SearchNOT = 3,
}

export interface IPersonnelTMDRoleActionCreator {
    (): IPersonnelTMDRoleAction
}

export interface IPersonnelTMDRoleAction {
    type: "ACTION_PERSONNEL_TMD_ROLE"
}

export interface IPersonnelTMDRoleSuccessAction {
    type: "ACTION_PERSONNEL_TMD_ROLE_SUCCESS";
    responseStatus: Dtos.ResponseStatus;
    tmdRole: PersonnelTmdRole[];
}

export interface IPersonnelTMDRoleFailureAction {
    type: "ACTION_PERSONNEL_TMD_ROLE_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTMDRoleSuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus,
        tmdRole: Dtos.PersonnelTmdRole[]
    ): IPersonnelTMDRoleSuccessAction;
}

export interface IPersonnelTMDRoleFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTMDRoleFailureAction;
}

export interface IPersonnelTMDRoleUpdateAction {
    type: "ACTION_PERSONNEL_TMD_ROLE_UPDATE";
    tmdRole: PersonnelTmdRole[];
    searchType: SearchType;
}

export interface IPersonnelTMDRoleUpdateActionCreator {
    (
        tmdRole: Dtos.PersonnelTmdRole[],
        searchType: SearchType
    ): IPersonnelTMDRoleUpdateAction;
}

// ----- TMD Trial

export interface IPersonnelTMDTrialActionCreator {
    (): IPersonnelTMDTrialAction
}

export interface IPersonnelTMDTrialAction {
    type: "ACTION_PERSONNEL_TMD_TRIAL"
}

export interface IPersonnelTMDTrialSuccessAction {
    type: "ACTION_PERSONNEL_TMD_TRIAL_SUCCESS";
    responseStatus: Dtos.ResponseStatus;
    tmdTrial: PersonnelTmdTrial[];
}

export interface IPersonnelTMDTrialFailureAction {
    type: "ACTION_PERSONNEL_TMD_TRIAL_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTMDTrialSuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus,
        tmdTrial: Dtos.PersonnelTmdTrial[]
    ): IPersonnelTMDTrialSuccessAction;
}

export interface IPersonnelTMDTrialFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTMDTrialFailureAction;
}

export interface IPersonnelTMDTrialUpdateAction {
    type: "ACTION_PERSONNEL_TMD_TRIAL_UPDATE";
    tmdTrial: PersonnelTmdTrial[];
    searchType: SearchType;
}

export interface IPersonnelTMDTrialUpdateActionCreator {
    (
        tmdTrial: Dtos.PersonnelTmdTrial[],
        searchType: SearchType
    ): IPersonnelTMDTrialUpdateAction;
}

// ----- Category

export interface IPersonnelCategoryActionCreator {
    (): IPersonnelCategoryAction
}

export interface IPersonnelCategoryAction {
    type: "ACTION_PERSONNEL_CATEGORY"
}

export interface IPersonnelCategorySuccessAction {
    type: "ACTION_PERSONNEL_CATEGORY_SUCCESS";
    responseStatus: Dtos.ResponseStatus;
    category: PersonnelCategory[];
}

export interface IPersonnelCategoryFailureAction {
    type: "ACTION_PERSONNEL_CATEGORY_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelCategorySuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus,
        category: PersonnelCategory[]
    ): IPersonnelCategorySuccessAction;
}

export interface IPersonnelCategoryFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelCategoryFailureAction;
}

export interface IPersonnelCategoryUpdateAction {
    type: "ACTION_PERSONNEL_CATEGORY_UPDATE";
    category: PersonnelCategory[];
    searchType: SearchType;
}

export interface IPersonnelCategoryUpdateActionCreator {
    (
        category: Dtos.PersonnelCategory[],
        searchType: SearchType
    ): IPersonnelCategoryUpdateAction;
}

// ----- Trial Group

export interface IPersonnelTrialGroupActionCreator {
    (): IPersonnelTrialGroupAction
}

export interface IPersonnelTrialGroupAction {
    type: "ACTION_PERSONNEL_TRIAL_GROUP"
}

export interface IPersonnelTrialGroupSuccessAction {
    type: "ACTION_PERSONNEL_TRIAL_GROUP_SUCCESS";
    responseStatus: Dtos.ResponseStatus;
    trialGroup: PersonnelTrialGroup[];
}

export interface IPersonnelTrialGroupFailureAction {
    type: "ACTION_PERSONNEL_TRIAL_GROUP_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IPersonnelTrialGroupSuccessActionCreator {
    (
        responseStatus: Dtos.ResponseStatus,
        trialGroup: Dtos.PersonnelTrialGroup[]
    ): IPersonnelTrialGroupSuccessAction;
}

export interface IPersonnelTrialGroupFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IPersonnelTrialGroupFailureAction;
}

export interface IPersonnelTrialGroupUpdateAction {
    type: "ACTION_PERSONNEL_TRIAL_GROUP_UPDATE";
    trialGroup: PersonnelTrialGroup[];
    searchType: SearchType;
}

export interface IPersonnelTrialGroupUpdateActionCreator {
    (
        trialGroup: Dtos.PersonnelTrialGroup[],
        searchType: SearchType
    ): IPersonnelTrialGroupUpdateAction;
}

// ------


export type PersonnelAction =
    IPersonnelLoadAction |
    IPersonnelLoadByIdAction |
    IPersonnelLoadFailureAction |
    IPersonnelLoadSuccessAction |
    IPersonnelSaveAction |
    IPersonnelSaveSuccessAction |
    IPersonnelSaveFailureAction |
    IPersonnelValidateAction |
    IPersonnelValidateSuccessAction |
    IPersonnelValidateFailureAction |
    IPersonnelSaveActiveDirectoryAction |
    IPersonnelSaveActiveDirectorySuccessAction |
    IPersonnelSaveActiveDirectoryFailureAction |
    IPersonnelCreateAction |
    IPersonnelCreateSuccessAction |
    IPersonnelCreateFailureAction |
    IPersonnelClearAction |
    IPersonnelFilterAction |
    IPersonnelResendEmailAction |
    IPersonnelResendEmailSuccessAction |
    IPersonnelResendEmailFailureAction |
    IPersonnelPermissionsLoadByIdAction |
    IPersonnelPermissionsLoadFailureAction |
    IPersonnelPermissionsLoadSuccessAction |
    IPersonnelByRoleLoadAction |
    IPersonnelByRoleLoadFailureAction |
    IPersonnelByRoleLoadSuccessAction |
    IPersonnelFilterByRoleAction |
    IPersonnelAdvancedSearchAction |
    IPersonnelAdvancedSearchFailureAction |
    IPersonnelAdvancedSearchSuccessAction |
    IPersonnelTMDRoleAction |
    IPersonnelTMDRoleFailureAction |
    IPersonnelTMDRoleSuccessAction |
    IPersonnelTMDTrialAction |
    IPersonnelTMDTrialFailureAction |
    IPersonnelTMDTrialSuccessAction |
    IPersonnelCategoryAction |
    IPersonnelCategoryFailureAction |
    IPersonnelCategorySuccessAction |
    IPersonnelTrialGroupAction |
    IPersonnelTrialGroupFailureAction |
    IPersonnelTrialGroupSuccessAction |
    IPersonnelTMDRoleUpdateAction |
    IPersonnelTMDTrialUpdateAction |
    IPersonnelCategoryUpdateAction |
    IPersonnelTrialGroupUpdateAction;
